import React from "react";
import { TrendingUp, Layers3, Users } from "lucide-react";
import SectionHeading from "./SectionHeading";

const cards = [
  {
    id: "01",
    title: "Competitive Advantage",
    icon: TrendingUp,
    description:
      "Stand out in a crowded market with a unique app experience tailored exclusively for your brand and audience.",
  },
  {
    id: "02",
    title: "Scalable Solution",
    icon: Layers3,
    description:
      "Accommodate growing user needs and evolve with your business — built on architecture that scales effortlessly.",
  },
  {
    id: "03",
    title: "Increased Engagement",
    icon: Users,
    description:
      "Foster deeper connections with customers through tailored features, personalization and intuitive UX.",
  },
];

export default function WhyCustom() {
  return (
    <section className="bg-[#F8F8FB] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Badge */}
        <div className="mb-12">
          <SectionHeading
            eyebrow="The Case for Custom"
            title="Why Custom Mobile Development?"
            description="Generic apps limit your potential. A custom solution is the difference between blending in and breaking through."
            theme="light"
            titleClassName="text-slate-900"
            descriptionClassName="max-w-4xl mx-auto text-lg leading-relaxed"
          />
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          {cards.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.id}
                className="group relative bg-white rounded-2xl border border-gray-200 p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:border-[#355dff]"
              >
                <div className="w-12 h-12 rounded-xl bg-[#EBF2FF] flex items-center justify-center text-[#355dff] mb-6 group-hover:bg-[#355dff] group-hover:text-white transition duration-300">
                  <Icon size={24} />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {item.title}
                </h3>

                <p className="text-gray-500 leading-7 text-[15px]">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}